import { motion, PRERENDU } from '../lib/motion';

/**
 * Le panneau d'un accordéon — replié à l'écran, présent partout ailleurs.
 *
 * ────────────────────────────────────────────────────────────────────────────
 * DEUX DÉFAUTS, ET LE MÊME PATRON RÉPÉTÉ TROIS FOIS
 * ────────────────────────────────────────────────────────────────────────────
 *
 * Le site avait trois accordéons — la FAQ de l'accueil, celle des pages de
 * prestation, celle des pages satellites — écrits trois fois, avec les mêmes
 * deux défauts :
 *
 *   `aria-hidden={!isOpen}`   retirait la réponse de l'arbre d'accessibilité.
 *                             C'est-à-dire de ce que voit un agent qui
 *                             navigue, et de ce que parcourt un lecteur
 *                             d'écran. La couche de connaissance métier du
 *                             site — neuf réponses sur l'accueil — était
 *                             invisible pour tout ce qui ne clique pas.
 *
 *   `animate={{ height: 0,    figeait `style="height:0px;opacity:0"` dans le
 *   opacity: 0 }}` au         HTML livré. Un agent qui filtre le contenu non
 *   pré-rendu                 visible — et il a raison de le faire — n'y
 *                             trouvait que des questions sans réponses.
 *
 * Le balisage `FAQPage` sauvait les moteurs de recherche. Il ne sauve pas un
 * agent qui lit la page : il ne le lit pas.
 *
 * ────────────────────────────────────────────────────────────────────────────
 * CE QUE FAIT CE COMPOSANT
 * ────────────────────────────────────────────────────────────────────────────
 *
 * `aria-hidden` n'est plus posé, dans aucun état. L'intention d'origine était
 * bonne — éviter qu'un lecteur d'écran annonce une réponse repliée — mais
 * `aria-expanded` sur le déclencheur dit déjà cela, et le dit mieux : il
 * annonce l'état sans effacer le contenu.
 *
 * Au pré-rendu, aucun style de repli n'est posé du tout : le HTML servi
 * contient les réponses en clair. Le premier rendu du navigateur replie
 * aussitôt, avant toute peinture — rien ne change pour qui visite la page.
 *
 * Le contrôle de build échoue si `opacity:0` réapparaît dans une page livrée.
 */
export default function PanneauRepliable({
  id,
  labelledBy,
  ouvert,
  children,
}: {
  id: string;
  /** `id` du déclencheur, pour nommer la région sans répéter la question. */
  labelledBy: string;
  ouvert: boolean;
  children: React.ReactNode;
}) {
  return (
    <motion.div
      id={id}
      role="region"
      aria-labelledby={labelledBy}
      initial={false}
      {...(PRERENDU
        ? {}
        : { animate: { height: ouvert ? 'auto' : 0, opacity: ouvert ? 1 : 0 } })}
      transition={{ duration: 0.3 }}
      className="overflow-hidden"
    >
      {children}
    </motion.div>
  );
}
